import { render, staticRenderFns } from "./appoint-explain.vue?vue&type=template&id=053cdb00&scoped=true"
import script from "./appoint-explain.vue?vue&type=script&lang=js"
export * from "./appoint-explain.vue?vue&type=script&lang=js"
import style0 from "./appoint-explain.vue?vue&type=style&index=0&id=053cdb00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053cdb00",
  null
  
)

export default component.exports